import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@images/right-arrow-orange.svg';
import _imports_1 from '@images/down-arrow-orange.svg';
const _withScopeId = n => (_pushScopeId("data-v-0859ad57"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = {
    key: 0,
    src: _imports_0,
    alt: "Right Arrow",
    class: "arrow-right",
    loading: "lazy"
};
const _hoisted_4 = {
    key: 1,
    class: "arrow-down",
    src: _imports_1,
    alt: "Down arrow",
    loading: "lazy"
};
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'two_column_bullet_list',
    props: ['d'],
    setup(__props) {
        const leftColumn = ref(null);
        const heading = ref(null);
        const rightColumn = ref(null);
        onMounted(() => {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0
            };
            const handleIntersection = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                        observer.unobserve(entry.target);
                    }
                });
            };
            const observer = new IntersectionObserver(handleIntersection, options);
            if (leftColumn.value && heading.value) {
                observer.observe(heading.value);
            }
            if (rightColumn.value) {
                rightColumn.value.querySelectorAll('h4').forEach(item => {
                    observer.observe(item);
                });
            }
        });
        // Check if the device is mobile based on screen width
        const isMobile = ref(window.innerWidth <= 992);
        // Update isMobile value when the window size changes
        window.addEventListener('resize', () => {
            isMobile.value = window.innerWidth <= 992;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "two_column_bullet_list",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: "col-lg-6 col-md-12 left_column",
                            ref_key: "leftColumn",
                            ref: leftColumn
                        }, [
                            _createElementVNode("h3", {
                                class: _normalizeClass({ 'absolute-brand': __props.d.absolute_brand_font == 'bold' })
                            }, [
                                _createTextVNode(_toDisplayString(__props.d.line_one), 1),
                                _createElementVNode("span", null, _toDisplayString(__props.d.line_two), 1)
                            ], 2),
                            (!isMobile.value)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                                : _createCommentVNode("", true),
                            (isMobile.value)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                                : _createCommentVNode("", true)
                        ], 512),
                        _createElementVNode("div", {
                            class: "col-lg-6 col-md-12",
                            ref_key: "rightColumn",
                            ref: rightColumn
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.two_column_bullet_repeatables, (item) => {
                                return (_openBlock(), _createElementBlock("h4", null, _toDisplayString(item.title), 1));
                            }), 256))
                        ], 512)
                    ])
                ])
            ], 4));
        };
    }
});
